import axios from 'axios';

//const API_URL = process.env.REACT_APP_API_URL;
const API_URL = "https://acoin.in.rs:8001";

// Kreiranje Axios instance sa osnovnim URL-om
const API = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor za dodavanje Authorization zaglavlja
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🔥 Helper za obradu error-a
const handleError = (error: unknown, fallbackMessage: string) => {
    if (error instanceof Error) {
        return new Error(error.message);
    }
    return new Error(fallbackMessage);
};

export const RegisterUser = async (userData: {
    username: string;
    email: string;
    password: string;
    repeated_password: string;
}) => {
    try {
        const response = await fetch(`${API_URL}/register/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || "An unknown error occurred. Please try again.");
        }

        return data;
    } catch (error: unknown) {
        console.error('Error during registration:', error);
        throw handleError(error, "Registration failed. Try again.");
    }
};

export const loginUser = async (userData: {
    username: string;
    password: string;
}) => {
    try {
        const response = await fetch(`${API_URL}/login/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || "An unknown error occurred. Please try again.");
        }

        return data;
    } catch (error: unknown) {
        console.error("Error during login:", error);
        throw handleError(error, "Login failed. Try again.");
    }
};

export const sendResetCode = async (formData: { email: string }) => {
    try {
        const response = await fetch(`${API_URL}/send-reset-code/`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.detail || "Greška pri slanju koda za reset lozinke");
        }

        return data;
    } catch (error: unknown) {
        throw handleError(error, "Došlo je do greške. Proverite unos i pokušajte ponovo.");
    }
};

export const verifyCode = async (formData: { email: string; code: string }) => {
    try {
        const response = await fetch(`${API_URL}/verify-code/`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.detail || "Greška pri proveri koda za reset lozinke");
        }

        return data;
    } catch (error: unknown) {
        throw handleError(error, "Došlo je do greške. Proverite unos i pokušajte ponovo.");
    }
};

export const resetPassword = async (formData: {
    email: string;
    newPassword: string;
}) => {
    try {
        const response = await fetch(`${API_URL}/reset-password/`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.detail || "Greška pri resetovanju lozinke");
        }

        return data;
    } catch (error: unknown) {
        throw handleError(error, "Došlo je do greške. Proverite unos i pokušajte ponovo.");
    }
};

export const getUserProfile = async (token: string) => {
    try {
        const response = await fetch(`${API_URL}/users/`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.detail || "Greška pri učitavanju profila");
        }

        return data;
    } catch (error: unknown) {
        throw handleError(error, "Došlo je do greške. Proverite unos i pokušajte ponovo.");
    }
};

export const updateUserProfile = async (updatedData: any, token: string) => {
    try {
        const response = await fetch(`${API_URL}/users/`, {
            method: "PUT",
            body: JSON.stringify(updatedData),
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || "Greška pri ažuriranju profila");
        }

        return data;
    } catch (error: unknown) {
        throw handleError(error, "Došlo je do greške. Proverite unos i pokušajte ponovo.");
    }
};